import LoginForm from './LoginForm';

export default LoginForm;



// WEBPACK FOOTER //
// ./src/client/Components/LoginForm/index.js